export default __webpack_public_path__ + "static/media/campaginWhite.9cbe7edd.svg";